import { Component } from '@angular/core';

@Component({
  selector: 'app-nueva-solicitud',
  templateUrl: './nueva-solicitud.component.html',
  styleUrls: ['./nueva-solicitud.component.css'],
})
export class NuevaSolicitudComponent {}
